import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@helpers/api';

export default function useChargebackDetails(chargebackId) {
    const { t } = useTranslation('banking');
    const [chargeback, setChargeback] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchChargeback = useCallback(async () => {
        if (!chargebackId) return;
        setLoading(true);
        setError(null);
        try {
            const { data } = await api.get(`charge/chargeback/${chargebackId}`);
            setChargeback(data);
        } catch (e) {
            console.error('Failed to fetch chargeback details', e);
            setError(t('chargebacks.details.loadError'));
        } finally {
            setLoading(false);
        }
    }, [chargebackId, t]);

    useEffect(() => {
        fetchChargeback();
    }, [fetchChargeback]);

    return {
        chargeback,
        loading,
        error,
        refetch: fetchChargeback,
    };
}
